var _g, _g2, _rect, _rect2, _circle, _g3, _circle2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 103,
    viewBox: "0 0 376 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10332_15197)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 350,
    height: 75,
    rx: 2.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10332_15197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323 33.75H343C343.332 33.75 343.649 33.8817 343.884 34.1161C344.118 34.3505 344.25 34.6685 344.25 35V55C344.25 55.3315 344.118 55.6495 343.884 55.8839C343.649 56.1183 343.332 56.25 343 56.25H323C322.668 56.25 322.351 56.1183 322.116 55.8839C321.882 55.6495 321.75 55.3315 321.75 55V35C321.75 34.6685 321.882 34.3505 322.116 34.1161C322.351 33.8817 322.668 33.75 323 33.75V33.75ZM331.754 50L340.591 41.1612L338.824 39.3937L331.754 46.465L328.217 42.9288L326.45 44.6962L331.754 50Z",
    fill: "#121B2E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 30,
    width: 133.75,
    height: 10,
    rx: 4.25,
    fill: "#EBEBEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 50,
    width: 73.75,
    height: 10,
    rx: 4.25,
    fill: "#EBEBEF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.25,
    cy: 47.5,
    r: 26.25,
    fill: "#EBEBEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10332_15197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.25 35C61.15 35 66.75 40.6 66.75 47.5C66.75 54.4 61.15 60 54.25 60C47.35 60 41.75 54.4 41.75 47.5C41.75 40.6 47.35 35 54.25 35ZM46.7787 51.77C48.6137 54.5075 51.3687 56.25 54.45 56.25C57.53 56.25 60.2862 54.5088 62.12 51.77C60.0397 49.8257 57.2974 48.746 54.45 48.75C51.6021 48.7457 48.8594 49.8255 46.7787 51.77V51.77ZM54.25 46.25C55.2446 46.25 56.1984 45.8549 56.9017 45.1517C57.6049 44.4484 58 43.4946 58 42.5C58 41.5054 57.6049 40.5516 56.9017 39.8483C56.1984 39.1451 55.2446 38.75 54.25 38.75C53.2554 38.75 52.3016 39.1451 51.5983 39.8483C50.8951 40.5516 50.5 41.5054 50.5 42.5C50.5 43.4946 50.8951 44.4484 51.5983 45.1517C52.3016 45.8549 53.2554 46.25 54.25 46.25V46.25Z",
    fill: "#09121F"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 12.5,
    r: 12.5,
    fill: "#121B2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8853 18.209V16.7814L15.6726 13.0687C16.0348 12.7029 16.3367 12.378 16.5782 12.0939C16.8196 11.8098 17.0008 11.5346 17.1215 11.2683C17.2422 11.002 17.3026 10.7179 17.3026 10.416C17.3026 10.0716 17.2245 9.77681 17.0682 9.53178C16.912 9.2832 16.6971 9.09144 16.4237 8.9565C16.1503 8.82156 15.8395 8.75408 15.4915 8.75408C15.1329 8.75408 14.8186 8.82866 14.5487 8.97781C14.2788 9.1234 14.0693 9.33114 13.9201 9.60103C13.7745 9.87092 13.7017 10.1923 13.7017 10.5652H11.8214C11.8214 9.87269 11.9794 9.27077 12.2955 8.75941C12.6116 8.24805 13.0466 7.85209 13.6005 7.57156C14.1581 7.29102 14.7973 7.15075 15.5182 7.15075C16.2497 7.15075 16.8924 7.28746 17.4464 7.5609C18.0004 7.83434 18.4301 8.20898 18.7355 8.68484C19.0444 9.16069 19.1989 9.70401 19.1989 10.3148C19.1989 10.7232 19.1208 11.1245 18.9645 11.5186C18.8083 11.9128 18.5331 12.3496 18.1389 12.829C17.7483 13.3084 17.1996 13.889 16.4929 14.5708L14.6126 16.4831V16.5577H19.364V18.209H11.8853Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10332_15197",
    x: 0.5,
    y: 2.5,
    width: 375,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10332_15197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10332_15197",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10332_15197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(318 30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10332_15197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(39.25 32.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLoading);
export default __webpack_public_path__ + "static/media/content_loading.8b64ef720cef7a0541d9284e66973d2b.svg";
export { ForwardRef as ReactComponent };